












































import { Vue, Component } from "vue-property-decorator";
import shopCart from "@/store/modules/shopCart";

@Component
export default class ShopCart extends Vue {
  get isCartEmpty() {
    return shopCart.emptyCart;
  }

  get cartItems() {
    return shopCart.cartItems;
  }

  get cartCount() {
    return shopCart.cartCount;
  }

  get itemsPrice() {
    return shopCart.itemsPrice;
  }
  incrementItemQuantity(id: number) {
    shopCart.incrementItemQuantity(id);
  }

  decrementItemQuantity(id: number) {
    shopCart.decrementItemQuantity(id);
  }

  removeItem(id: number) {
    shopCart.removeItem(id);
  }
}
